import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

/**
 * Legacy fallback for the old client-side Google OAuth flow.
 *
 * The new Wokelo-managed flow goes server-side: backend handles the OAuth
 * code exchange in /api/auth/google/callback and 302s the browser straight
 * into the app with a session cookie already set. Nothing here is needed
 * during a healthy login.
 *
 * This page only exists so:
 *   1. Cached frontends that still hit /auth/callback don't break.
 *   2. Bookmarks of the old callback URL gracefully recover.
 *
 * It just redirects to /login (or /generator if the cookie is somehow
 * already present). Once we're confident no clients reach it, the route
 * can be removed.
 */
export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    // If the URL has a `?session_token=...` (it shouldn't anymore), we let
    // /auth/me sort it out on the destination page. Otherwise back to login.
    navigate("/login", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="flex items-center gap-3 text-gray-500 text-sm">
        <Loader2 className="w-4 h-4 animate-spin" />
        Returning you to sign in…
      </div>
    </div>
  );
}
